const expenseStatusesConstants = Object.freeze({
  TO_APPROVE: 0,
  APPROVED: 1,
  AWAITING_PAYMENT: 2,
  PAID: 3,
  DRAFT: 4,
  REJECTED: 5,
  TRANSACTION_AUTHORIZED: 6,
  TRANSACTION_REJECTED: 7,
  TRANSACTION_REFUND: 8,
  TRANSACTION_REVERSED: 9
});

const expenseTypesConstants = Object.freeze({
  INVOICE: 0,
  RECEIPT: 1,
  NO_RECEIPT: 2,
  PROCESSING: 3,
});

const expenseInvoicesStatusConstants = Object.freeze({
  CONFIRMED: 'CONFIRMED',
  MATCHED: 'MATCHED',
  PENDING: 'PENDING',
});

const expensePaymentMethodConstants = Object.freeze({
  PAID_BY_EMPLOYEE: 0,
  CARD: 1,
  WIRE: 2,
  REIMBURSEMENT: 3,
  OPEN_BANKING: 4,
});

const expensePaymentMethodGroupConstants = Object.freeze({
  EMPLOYEE_PAID: 0,
  COMPANY_PAID: 1,
});

const expensePolicyStatusConstants = Object.freeze({
  OUT_OF_POLICY: 'out_of_policy',
  MISSING_INFO: 'missing_info',
});

const expenseReviewStatusConstants = Object.freeze({
  DRAFT: 'draft',
  IN_REVIEW: 'in_review',
  APPROVED: 'approved',
  PARTIALLY_APPROVED: 'partially_approved',
  REIMBURSED: 'reimbursed',
  RECLAIMED: 'reclaimed',
  REJECTED: 'rejected'
});

const expensesPlanConstants = Object.freeze({
  ADVANCED: 'advanced',
  BASIC: 'basic',
});

const expenseCategoryTagConstants = Object.freeze({
  MILEAGE: 'mileage',
});

const expenseDocumentFilterConstants = Object.freeze({
  INVOICE_REQUESTED: 'invoice_requested',
});

const INVOICE_REQUESTED_REFETCH_DELAY_MS = 60000;

const DOCUMENT_PROCESSING_POLL_INTERVAL_MS = 5000;

const DOCUMENT_PROCESSING_MAX_POLLS = 24;

const expenseTypeSelectionConstants = Object.freeze({
  EXPENSE: 'expense',
  MILEAGE: 'mileage',
  UPLOAD_DOCUMENT: 'upload_document',
});

export {
  expenseStatusesConstants,
  expenseTypesConstants,
  expenseInvoicesStatusConstants,
  expensePaymentMethodConstants,
  expensePaymentMethodGroupConstants,
  expensePolicyStatusConstants,
  expenseReviewStatusConstants,
  expensesPlanConstants,
  expenseCategoryTagConstants,
  expenseTypeSelectionConstants,
  expenseDocumentFilterConstants,
  DOCUMENT_PROCESSING_MAX_POLLS,
  DOCUMENT_PROCESSING_POLL_INTERVAL_MS,
  INVOICE_REQUESTED_REFETCH_DELAY_MS,
};

